module.exports = __webpack_public_path__ + "static/media/3.4facd4a2.jpg";